import React, { useState } from "react";
import { Loader2, Mic, Square } from "lucide-react";
import { api } from "../../lib/api";
import { FieldInput } from "../TabContentEditor";
import { useRecorder } from "../TabFeed";

export const SAV_CLIENT = [["civilite", "Civilité"], ["nom", "Nom"], ["prenom", "Prénom"], ["telephone", "Téléphone"], ["email", "Email"],
  ["adresse", "Adresse"], ["code_postal", "Code postal"], ["ville", "Ville"]];
export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("fr-FR") : "—");

export function DictateButton({ onText, testid }) {
  const mic = useRecorder(onText);
  return (
    <button type="button" onClick={mic.toggle} disabled={mic.state === "busy"} title="Dicter (transcrit par l'IA)" data-testid={testid}
      className={`inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded border transition-colors ${mic.state === "rec" ? "bg-red-50 border-red-300 text-red-700" : "border-norea-border text-norea-textMuted hover:text-norea-text"}`}>
      {mic.state === "busy" ? <Loader2 className="w-3 h-3 animate-spin" /> : mic.state === "rec" ? <Square className="w-3 h-3" /> : <Mic className="w-3 h-3" />}
      {mic.state === "rec" ? "Arrêter" : mic.state === "busy" ? "Transcription…" : "Dicter"}
    </button>
  );
}

export function SavField({ f, value, onChange }) {
  return (
    <label className={`block space-y-1 ${f.type === "textarea" ? "md:col-span-2" : ""}`}>
      <span className="flex items-center justify-between text-[11px] text-norea-textMuted">
        {f.label}
        {f.type === "textarea" && <DictateButton onText={(t) => onChange(value ? `${value} ${t}` : t)} testid={`sav-dictate-${f.id}`} />}
      </span>
      <FieldInput field={f} value={value} onChange={onChange} testid={`sav-field-${f.id}`} />
    </label>
  );
}

export function SavFieldsGrid({ fields, values, onChange }) {
  return <div className="grid md:grid-cols-2 gap-3">{fields.map((f) => <SavField key={f.id} f={f} value={values[f.id]} onChange={(v) => onChange(f.id, v)} />)}</div>;
}

export function PeopleSelects({ opts, sub, emp, onSub, onEmp }) {
  const cls = "w-full px-2 py-1.5 text-sm border border-norea-border rounded bg-white focus:ring-1 focus:ring-norea-primary outline-none";
  return (
    <div className="grid md:grid-cols-2 gap-3">
      <label className="block space-y-1"><span className="text-[11px] text-norea-textMuted">Sous-traitant chargé du SAV</span>
        <select value={sub || ""} onChange={(e) => onSub(e.target.value || null)} className={cls} data-testid="sav-subcontractor">
          <option value="">— Aucun pour l'instant —</option>
          {opts.subcontractors.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select></label>
      <label className="block space-y-1"><span className="text-[11px] text-norea-textMuted">Salarié Norea qui suit</span>
        <select value={emp || ""} onChange={(e) => onEmp(e.target.value || null)} className={cls} data-testid="sav-employee">
          <option value="">—</option>
          {opts.employees.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select></label>
    </div>
  );
}

export function useSavOptions() {
  const [opts, setOpts] = useState(null);
  React.useEffect(() => { api.get("/sav/options").then((r) => setOpts(r.data)).catch(() => setOpts(null)); }, []);
  return opts;
}
